import StudentsAnalyticsView from "@features/students/view/single-analytics-view";

const StudentsAnalytics = () => {
  return <StudentsAnalyticsView />;
};

export default StudentsAnalytics;
